import PropTypes from 'prop-types';
import React from "react";
import { Link } from "react-router-dom";
import buildUrl from "build-url-ts";

import { Row, Col } from "react-bootstrap";


import { ToolBar, ToolBarGroup } from "src/legacy/components/ToolBar/ToolBar.jsx";

import { ToolBarButtonItem } from "src/legacy/components/ToolBar/ToolBarButtonItem.jsx";
import SeekSearch from 'src/pages/seek/components/seekSearch/index.tsx';

import AssetSearchResultContainer from "./asset/AssetSearchResultContainer.jsx";
import CustomFieldSearchViewContainer from "./customField/CustomFieldSearchViewContainer";
import SearchResultView from "./SearchResultView.jsx";
import SeekResponse from './seekResponse/index.jsx';

import styles from "./styles.module.scss";
import cx from "classnames";
import _ from "lodash";

import { localizedStrings } from 'src/localization';
import userRoleService from 'src/utils/userRoles.service.js';
import SeekLandingPage from './seekSearchLandingPage'
import Button from "src/components/button";
import EmptyContentView from './EmptyMessageNewUi/EmptyContentView.jsx';

const Logo = '/images/logoSeek.png';

class SearchView extends React.Component {
  static childContextTypes = {
    recordAssetClicked: PropTypes.func,
  };

  constructor(props) {
    super(props);

    this.state = {
      query: "",
      isSearch: false,
      filter: "all",
      fields: "",
      showSeekSearch: false,
      selectedQuestion: "",
      searchedQuery: "",
    };

    this.primaryBackground = null;
    this.recordAssetClicked = this.recordAssetClicked.bind(this);
    this._onQueryChange = this._onQueryChange.bind(this);
    this._handleSearch = this._handleSearch.bind(this);
    this.handleViewMoreClick = this.handleViewMoreClick.bind(this);
    this.onFilterChange = this.onFilterChange.bind(this);
    this._handleFieldsFilterChange = this._handleFieldsFilterChange.bind(this);
    this.searchDataExists = this.searchDataExists.bind(this);
    this.handleSeekRedirect = this.handleSeekRedirect.bind(this);

    this.localizedCommons = localizedStrings.commons;
    this.localizedSearch = localizedStrings.pages.search;
    this.localizedKeywords = localizedStrings.keywords;

  }

  componentWillMount(){
    this.props.fetchSeekQASuggestions();
  }

  componentWillUnmount() {
    this.invalidateSearch();
  }

  componentWillReceiveProps(nextProps) {
    if (!_.isEqual(this.props, nextProps)) {
      this.setState({
        isSearchDataExists: this.searchDataExists(nextProps)
      })
    }
  }

  getChildContext() {
    return {
      recordAssetClicked: this.recordAssetClicked,
    };
  }

  onFilterChange(filter) {
    this.setState({
      filter: filter,
    });
    this.handleViewMoreClick(filter);
  }

  _onQueryChange(e) {
    this.setState({
      query: e.target.value,
    });
  }

  _handleSearch(e) {

    if (e) {
      e.preventDefault();
    }

    var query = this.state.query;
    var url = "/search";


    if (query != "" && typeof query !== "undefined") {
      url = `${url}?query=${query}`;
    }
    this.setState({
    searchedQuery: query
  });
    this.props.navigate(url);
    this.invalidateSearch();

    const filterName = _.get(this.state, 'filter');
    var filterType = filterName === "all" ? "Everything" : _.capitalize(filterName);

    if (query == "" || typeof query === "undefined") {
      return;
    }
    this.props.trackAdoptionMetricsForContentSearchEvent("Global Search", query, filterType, [], {});
    this.props.searchAsset(this.state.query, null, 0, 12, true, false);
    {
      userRoleService.canAccessCollection() &&
        this.props.searchCollections(this.state.query, 0, 12, true);
    }

    {
      this.props.account.hubEnabled &&
        this.props.searchStreams(this.state.query, null, 0, 12, true);
    }
    this.props.fetchTags(this.state.query);
    this.props.searchContacts(
      this.state.query,
      true,
      0,
      12,
      true
    );
    this.props.searchContactLists(this.state.query, 0, 12, true);

    this.props.recordSearchQuery({
      query: this.state.query,
    });
  }

  invalidateSearch() {
    this.props.invalidateAssetSearchResult();
    this.props.invalidateCollectionsSearchResult();
    this.props.invalidateStreamsSearchResult();
    this.props.invalidateContactsSearchResult();
    this.props.invalidateContactListsSearchResult();
    this.props.invalidateTags();
  }

  handleViewMoreClick(field) {
    var url = `/search/${field}`;

    if (this.state.query != "" && typeof this.state.query !== "undefined") {
      url = `${url}?query=${this.state.query}`;
    }

    this.props.navigate(url);
  }

  _handleFieldsFilterChange(fields) {
    var url = `/search/assets`;

    var query = this.state.query;
    var queryParams = {};

    if (query != "" && typeof query !== "undefined") {
      queryParams["query"] = query;
    }

    var fieldQuery = this.convertFieldsFilterToQueryParams(fields);
    if (fieldQuery) {
      queryParams["fields"] = fieldQuery;
    }

    url = buildUrl(url, {
      queryParams: queryParams,
    });

    this.props.navigate(url);
  }

  convertFieldsFilterToQueryParams(fields) {
    if (!fields || fields.length == 0) {
      return null;
    }

    var query = fields.map((field) => {
      var optionsQuery = field.options.map((o) => {
        return o.index;
      }).join("|");
      return field.index + "|" + optionsQuery;
    }).join(",");

    return query;
  }

  recordAssetClicked(asset) {
    this.props.recordSearchQuery({
      query: this.state.query,
      asset: asset,
    });
  }

  componentDidMount() {
    window.localStorage.setItem('seek', false);

    this.primaryBackground = _.get(
      this.props.account,
      "theme.primaryPalette.backgroundColor"
    );

    this.props.trackAdoptionMetricsForSearchScreenView();


    this.props.fetchCustomFields();

    if (this.props.location.query) {
      this.setState(
        {
          query: _.get(this.props, "location.query.query"),
          tags: _.get(this.props, "location.query.tags"),
        },
        () => {
          this._handleSearch();
        }
      );
    } else {
      this.invalidateSearch();
    }
  }

  handleClearQuery(e){
    if (e && e.preventDefault) {
      e.preventDefault();
    }
    this.setState({
      query: ""
    })
    this.props.navigate("/search", { replace: true });
    this.invalidateSearch();
  }

  searchDataExists() {
    const props = this.props;
    const assets = _.get(props, "assets.items");
    const collections = _.get(props, "collections.items");
    const streams = _.get(props, "streams.items");
    const contactsList = _.get(props, "contactLists.items");
    return _.size(assets) > 0 || _.size(collections) > 0 || _.size(streams) > 0 || _.size(contactsList) > 0
  }

  handleSeekRedirect(question){
    this.setState({
      showSeekSearch: true,
      selectedQuestion: question,
    });
  };

  clearValue(){
    this.setState({
      query: ""
    })
    this.invalidateSearch();
  }

  handleSeekClose = () => {
    this.setState({
      showSeekSearch: false,
      selectedQuestion: null,
    });
  };

  render() {
    const seekEnabled = _.get(this.props, "account.seekEnabled");
    const hasQuery = _.size(_.get(this.props, "location.query.query","")) > 0;

    return (
      <div className={cx(styles.content, "search_page")}>
        <Col
          sm={12}
          className={{
            [styles.globalSearchContainer]:
              _.size(_.get(this.props, "customFields", [])) > 0,
          }}
        >
          <Row className={styles.top}>
            <Col sm={12} className={cx(styles.column, styles.searchBar)}>
              <Col sm={9} className={cx(styles.column, styles.noPadding)}>
                <div className={styles.titleContainer} >
                  <h1 className={styles.pageTitle}>{this.localizedSearch.title}</h1>
                  {!seekEnabled && <p className={styles.subTitle}>{this.localizedSearch.sub_text}</p>}
                  {seekEnabled && <p className={styles.seekSearch}> { this.localizedSearch.seek_enabled.sub_text} <span className={styles.seekText}> { this.localizedKeywords.seek } </span></p>}
                </div>
              </Col>
              <Col sm={3} className={cx(styles.noPadding)} xsHidden></Col>
            </Col>

            <SeekLandingPage
              location={this.props.location}
              query={this.state.query}
              isSearchDataExists={this.searchDataExists()}  
              isFetching={() => this.validateLoadingMessage()}
              _onQueryChange={this._onQueryChange.bind(this)}
              _handleSearch={this._handleSearch}
              clearValue={this.handleClearQuery.bind(this)}
              isCustomFieldsAvailable={_.size(_.get(this.props, "customFields", [])) > 0}
            />
            

          </Row>
          {this.state.showSeekSearch && (
          <SeekSearch
            question={this.state.selectedQuestion}
            onClose={this.handleSeekClose}
            isLimitExceeded={this.props.isSeekLimitExceeded}
          />
          )}
          {hasQuery && this.state.searchedQuery && (
            <div className={styles.resultBill}>
            <div className={styles.resultTitle}>
              showing results for <span className={styles.queryName}>"{this.state.searchedQuery}"</span>
            </div>
            </div>
          )}
          
         { hasQuery && <SeekResponse 
              location={this.props.location} 
              query={this.state.query} 
              isFetching={() => this.validateLoadingMessage()} 
              _onQueryChange={this._onQueryChange.bind(this)} 
              _handleSearch={this._handleSearch} 
              clearValue={this.handleClearQuery.bind(this)}
          />}

          { hasQuery && this.state.isSearchDataExists && this._renderFilterGroup()}

          { hasQuery && this.validateLoadingMessage() && this._renderLoadingMessage()}

          { hasQuery && this.validateEmptyMessage() && !this.validateLoadingMessage() && this.renderEmptyMessage()}

          {hasQuery && _.size(_.get(this.props, "assets.items", [])) > 0 && (
            <Row className={styles.container}>
              <Col sm={12} className={cx(styles.column, styles.noPadding)}>
                <div className={styles.section}>
                  <label className={cx(styles.item, styles.text)}>
                    {`${this.localizedKeywords.assets} (${this.props.assets.totalRecordsCount})`}
                  </label>
                </div>
              </Col>
              {this.renderTagView()}
              <AssetSearchResultContainer items={this.props.assets.items} />
              {this.renderPagination("assets", this.props.assets)}
            </Row>
          )}

          {hasQuery && _.size(_.get(this.props, "collections.items", [])) > 0 && (
            <Row className={styles.container}>
              <Col sm={12} className={cx(styles.column, styles.noPadding)}>
                <div className={styles.section}>
                  <label className={cx(styles.item, styles.text)}>
                    {`${this.localizedKeywords.collections} (${this.props.collections.totalRecordsCount})`}
                  </label>
                </div>
              </Col>
              <SearchResultView items={this.props.collections.items} />
              {this.renderPagination("collections", this.props.collections)}
            </Row>
          )}

          {hasQuery && _.size(_.get(this.props, "streams.items", [])) > 0 && (
            <Row className={styles.container}>
              <Col sm={12} className={cx(styles.column, styles.noPadding)}>
                <div className={styles.section}>
                  <label className={cx(styles.item, styles.text)}>
                    {`${this.localizedKeywords.streams} (${this.props.streams.totalRecordsCount})`}
                  </label>
                </div>
              </Col>
              <SearchResultView items={this.props.streams.items} />
              {this.renderPagination("streams", this.props.streams)}
            </Row>
          )}

          {hasQuery &&_.size(_.get(this.props, "contacts.items", [])) > 0 && (
            <Row className={styles.container}>
              <Col sm={12} className={cx(styles.column, styles.noPadding)}>
                <div className={styles.section}>
                  <label className={cx(styles.item, styles.text)}>
                    {`${this.localizedKeywords.contacts} (${this.props.contacts.totalRecordsCount})`}
                  </label>
                </div>
              </Col>

              <SearchResultView items={this.props.contacts.items} />
              {this.renderPagination("contacts", this.props.contacts)}
            </Row>
          )}

          {hasQuery && _.size(_.get(this.props, "contactLists.items", [])) > 0 && (
            <Row className={styles.container}>
              <Col sm={12} className={cx(styles.column, styles.noPadding)}>
                <div className={styles.section}>
                  <label className={cx(styles.item, styles.text)}>
                    {` ${this.localizedKeywords.contact_lists} (${this.props.contactLists.totalRecordsCount})`}
                  </label>
                </div>
              </Col>

              <SearchResultView items={this.props.contactLists.items} />
              {this.renderPagination("contactLists", this.props.contactLists)}
            </Row>
          )}

        </Col>
        {_.size(_.get(this.props, "customFields", [])) > 0 && (
          <Col sm={2}>
            <CustomFieldSearchViewContainer
              fields={this.props.customFields}
              value={[]}
              onChange={this._handleFieldsFilterChange}
            />
          </Col>
        )}

      </div>
    );
  }

  validateLoadingMessage() {
    if (this.props.assetsSearching) {
      return true;
    } else if (this.props.collectionsSearching) {
      return true;
    } else if (this.props.streamsSearching) {
      return true;
    } else if (this.props.contactsSearching) {
      return true;
    } else if (this.props.contactListsSearching) {
      return true;
    }
    return false;
  }

  validateEmptyMessage() {

  const hasNoResults = (
    _.size(_.get(this.props, "assets.items", [])) == 0 &&
    _.size(_.get(this.props, "collections.items", [])) == 0 &&
    _.size(_.get(this.props, "streams.items", [])) == 0 &&
    _.size(_.get(this.props, "contacts.items", [])) == 0 &&
    _.size(_.get(this.props, "contactLists.items", [])) == 0
  );

  return _.get(this.props, "assets.query") && hasNoResults && !this.validateLoadingMessage()

}


renderEmptyMessage() {
      
  return (
   <EmptyContentView searchQuery={_.get(this.props, "assets.query")}></EmptyContentView>
  );
}


  _renderLoadingMessage() {
    return <div className={styles.loadingMessage}>{this.localizedCommons.actions.searching}...</div>;
  }

  _renderFilterGroup() {
    return (
      <ToolBar className={styles.toolbar}>
        <ToolBarGroup item={styles.item}>
          <ToolBarButtonItem
            className={cx(styles.filterHeading)}
            width="auto"
            height="auto"
          >
            <div> {this.localizedSearch.filters.title} : </div>
          </ToolBarButtonItem>
          <ToolBarButtonItem
            className={cx(styles.filter)}
            width="auto"
            height="auto"
          >
            <div
              className={cx(styles.link, {
                [styles.active]: this.state.filter == "all",
              })}
            >
              {this.localizedSearch.filters.everything}
            </div>
          </ToolBarButtonItem>
          <ToolBarButtonItem
            className={cx(styles.filter)}
            width="auto"
            height="auto"
          >
            <div
              className={cx(styles.link, {
                [styles.active]: this.state.filter == "assets",
              })}
              onClick={this.onFilterChange.bind(this, "assets")}
            >
              {this.localizedKeywords.assets}
            </div>
          </ToolBarButtonItem>
          {userRoleService.canAccessCollection() &&
            <ToolBarButtonItem
              className={cx(styles.filter)}
              width="auto"
              height="auto"
            >

              <div
                className={cx(styles.link, {
                  [styles.active]: this.state.filter == "collections",
                })}
                onClick={this.onFilterChange.bind(this, "collections")}
              >
                {this.localizedKeywords.collections}
              </div>
            </ToolBarButtonItem>
          }
          {userRoleService.canAccessHub() && this.props.account.hubEnabled && (
            <ToolBarButtonItem
              className={cx(styles.filter)}
              width="auto"
              height="auto"
            >
              <div
                className={cx(styles.link, {
                  [styles.active]: this.state.filter == "streams",
                })}
                onClick={this.onFilterChange.bind(this, "streams")}
              >
                {this.localizedKeywords.streams}
              </div>
            </ToolBarButtonItem>
          )}
          {userRoleService.canShare() &&
            <ToolBarButtonItem
              className={cx(styles.filter)}
              width="auto"
              height="auto"
            >
              <div
                className={cx(styles.link, {
                  [styles.active]: this.state.filter == "contacts",
                })}
                onClick={this.onFilterChange.bind(this, "contacts")}
              >
                {this.localizedKeywords.contacts}
              </div>
            </ToolBarButtonItem>
          }
          {userRoleService.canShare() &&
            <ToolBarButtonItem
              className={cx(styles.filter)}
              width="auto"
              height="auto"
            >
              <div
                className={cx(styles.link, {
                  [styles.active]: this.state.filter == "contactLists",
                })}
                onClick={this.onFilterChange.bind(this, "contactLists")}
              >
                {this.localizedKeywords.contact_lists}
              </div>
            </ToolBarButtonItem>
          }
        </ToolBarGroup>
      </ToolBar>
    );
  }

  renderTagView() {
    if (!(this.props.tags && this.props.tags.length > 0)) {
      return false;
    }

    return (
      <Col md={12} className={styles.noPadding}>
        <div className={styles.tagView}>
          <Link
            key={"all"}
            className={cx(styles.tag, {
              [styles.active]: !_.get(this.props, "location.query.tags"),
            })}
            to={`/search/assets?query=${this.state.query}`}
          >
            #{this.localizedSearch.asset.all_tags} ({this.props.totalItems}),
          </Link>
          {this.renderTags()}
        </div>
      </Col>
    );
  }

  renderTags() {
    return _.get(this.props, "tags", []).map((tag, index) => {
      return (
        <Link
          key={index}
          className={styles.tag}
          to={`/search/assets?query=${this.state.query}&tags=${tag.key}`}
        >
          #{tag.key} ({tag.count}),
        </Link>
      );
    });
  }

  renderPagination(entityType, pagination) {
    var remainingItems =
      pagination.totalRecordsCount - pagination.recordsPerPage;
    if (remainingItems <= 0) {
      return false;
    }

    return (
      <div className={styles.pagination}>
        <div
          className={cx(styles.item, styles.text, styles.action)}
          onClick={() => this.handleViewMoreClick(entityType)}
        >
          <i className="paperflite-plus"></i>
          <span className={styles.upperCase}>{`${this.localizedCommons.actions.view_more} (${remainingItems})`}</span>
        </div>
      </div>
    );
  }
}

export default SearchView;